<template>
  <pagefra>
    <div
      class="annualInspectionPlan container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            :model="form"
            inline
            class="toolbar-form"
            @submit.native.prevent
          >
            <el-form-item :label="$l('年检状态')">
              <el-select
                v-model="form.status"
                :placeholder="$l('年检状态')"
                clearable
              >
                <el-option :label="$l('已计划')" value="已计划"></el-option>
                <el-option :label="$l('已完成')" value="已完成"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('需限速器试验')">
              <el-select
                v-model="form.needSpeedLimit"
                :placeholder="$l('需限速器试验')"
                clearable
              >
                <el-option :label="$l('是')" value="是"></el-option>
                <el-option :label="$l('空')" value="空"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('需下行制动试验')">
              <el-select
                v-model="form.needDownBrake"
                :placeholder="$l('需下行制动试验')"
                clearable
              >
                <el-option :label="$l('是')" value="是"></el-option>
                <el-option :label="$l('空')" value="空"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.assetNum"
                :placeholder="$l('工号')"
                clearable
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.projName"
                :placeholder="$l('地盘名称')"
                clearable
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('计划年检月份')">
              <el-date-picker
                v-model="form.date"
                type="month"
                :placeholder="$l('选择月份')"
                value-format="yyyy-MM"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$l('实际年检日期')">
              <el-date-picker
                v-model="timeValues"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始日期')"
                :end-placeholder="$l('结束日期')"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              round
              icon="el-icon-date"
              @click="openCalendarDialog"
              v-if="hasPermission('年检日历')"
            >
              {{ $l("年检日历") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="assetNum"
              align="center"
              min-width="160"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="projName"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('客户')"
              prop="propertyName"
              align="center"
              min-width="140"
            ></el-table-column>
            <el-table-column
              :label="$l('年检年度')"
              prop="annualCheckYear"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('计划年检月份')"
              prop="annualCheckMonth"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('年检状态')"
              prop="annualCheckStatus"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('实际年检日期')"
              prop="annualCheckReal"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('需限速器试验')"
              prop="needSpeedLimit"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('需下行制动试验')"
              prop="needDownBrake"
              align="center"
              min-width="130"
            ></el-table-column>
            <el-table-column :label="$l('状态')" align="center" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.status }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('下载')"
              align="center"
              width="100"
              fixed="right"
              v-if="hasPermission('下载')"
            >
              <template slot-scope="scope">
                <i
                  v-if="scope.row.annuaCheckDownloadUrl"
                  class="el-icon-download download-icon"
                  @click="downloadFile(scope.row)"
                ></i>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :title="$l('年检日历')"
        :visible.sync="calendarDialogVisible"
        width="760px"
        top="8vh"
        append-to-body
      >
        <div v-loading="calendarLoading" class="calendar-dialog__body">
          <div class="calendar-dialog__toolbar">
            <el-date-picker
              v-model="calendarDate"
              type="month"
              size="small"
              value-format="yyyy-MM"
              :placeholder="$l('选择月份')"
              :clearable="false"
              @change="handleCalendarMonthChange"
            ></el-date-picker>
            <div class="calendar-dialog__stats">
              <div class="calendar-dialog__stat calendar-dialog__stat--total">
                <span class="calendar-dialog__stat-label">{{
                  $l("总数")
                }}</span>
                <span class="calendar-dialog__stat-value">{{
                  calendarData.total
                }}</span>
              </div>
              <div
                class="calendar-dialog__stat calendar-dialog__stat--completed"
              >
                <span class="calendar-dialog__stat-label">{{
                  $l("已完成")
                }}</span>
                <span class="calendar-dialog__stat-value">{{
                  calendarData.completed
                }}</span>
              </div>
              <div class="calendar-dialog__legend">
                <span class="calendar-dialog__legend-dot"></span
                >{{ $l("当日已完成年检数量") }}
              </div>
            </div>
          </div>
          <el-calendar
            v-model="calendarValue"
            class="calendar-dialog__calendar"
          >
            <template slot="dateCell" slot-scope="scope">
              <div
                class="calendar-cell"
                :class="{
                  'calendar-cell--other': scope.data.type !== 'current-month',
                }"
              >
                <span class="calendar-cell__day">
                  {{ scope.data.day.split("-")[2] }}
                </span>
                <span
                  v-if="
                    scope.data.type === 'current-month' &&
                    getCalendarCount(scope.data.day)
                  "
                  class="calendar-cell__count"
                >
                  {{ getCalendarCount(scope.data.day) }}
                </span>
              </div>
            </template>
          </el-calendar>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
import dayjs from "dayjs";
export default {
  name: "annualInspectionPlan",
  mixins: [global],
  components: {
    panel,
  },
  data() {
    return {
      timeValues: [],
      form: {
        status: "",
        needSpeedLimit: "",
        needDownBrake: "",
        assetNum: "",
        projName: "",
        date: "",
      },
      tableData: [],
      loading: false,
      fullLoading: false,
      calendarDialogVisible: false,
      calendarDate: dayjs().format("YYYY-MM"),
      calendarValue: dayjs().startOf("month").format("YYYY-MM-DD"),
      calendarLoading: false,
      calendarData: {
        total: 0,
        completed: 0,
        calendar: [],
      },
    };
  },
  created() {
    this.pageConfig.pageChangeCallback = this.loadData;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    search() {
      this.pageConfig.currentPage = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      const params = {
        page: this.pageConfig.currentPage,
        limit: this.pageConfig.pageSize,
        status: this.form.status,
        needSpeedLimit: this.form.needSpeedLimit,
        needDownBrake: this.form.needDownBrake,
        assetNum: this.form.assetNum,
        projName: this.form.projName,
        date: this.form.date,
      };
      if (this.timeValues && this.timeValues.length == 2) {
        params.dateStart = this.timeValues[0];
        params.dateEnd = this.timeValues[1];
      }
      this.$http
        .post(this.$apiConfig.get_fd_annual_inspection_list_url, params)
        .then((response) => {
          this.loading = false;
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.tableData = data.rows || [];
            this.pageConfig.total = data.total || 0;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    openCalendarDialog() {
      this.calendarDate = dayjs().format("YYYY-MM");
      this.calendarValue = dayjs().startOf("month").format("YYYY-MM-DD");
      this.calendarDialogVisible = true;
      this.loadCalendar();
    },
    handleCalendarMonthChange(val) {
      if (!val) return;
      this.calendarDate = val;
      this.calendarValue = dayjs(val + "-01").format("YYYY-MM-DD");
      this.loadCalendar();
    },
    loadCalendar() {
      this.calendarLoading = true;
      this.$http
        .get(this.$apiConfig.get_fd_annual_inspection_calendar_url, {
          params: {
            date: this.calendarDate,
          },
        })
        .then((response) => {
          this.calendarLoading = false;
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.calendarData = {
              total: data.total || 0,
              completed: data.completed || 0,
              calendar: data.calendar || [],
            };
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.calendarLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    getCalendarCount(date) {
      const item = this.calendarData.calendar.find((i) => i.date === date);
      return item ? item.number : 0;
    },
    downloadFile(row) {
      if (!row.annuaCheckDownloadUrl) return;
      this.$http
        .get(this.$apiConfig.get_fd_emes_download_url, {
          params: {
            fileUrl: row.annuaCheckDownloadUrl,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            const raw = result.data || "";
            let base64 = raw;
            const commaIndex = raw.indexOf(",");
            if (raw.indexOf("data:") === 0 && commaIndex > -1) {
              base64 = raw.substring(commaIndex + 1);
            }
            if (!base64) {
              this.message(-1, "获取下载文件失败");
              return;
            }
            const typeMap = {
              pdf: "application/pdf",
              jpg: "image/jpeg",
              jpeg: "image/jpeg",
              png: "image/png",
              gif: "image/gif",
              bmp: "image/bmp",
              webp: "image/webp",
              svg: "image/svg+xml",
            };
            const urlPath = row.annuaCheckDownloadUrl.split("?")[0];
            const lastDot = urlPath.lastIndexOf(".");
            const lastSlash = urlPath.lastIndexOf("/");
            const ext =
              lastDot > lastSlash
                ? urlPath.substring(lastDot + 1).toLowerCase()
                : "";
            const fileType = typeMap[ext] || "application/octet-stream";
            const filename =
              row.assetNum +
              "-" +
              row.annualCheckYear +
              "-年检报告." +
              (ext || "file");
            const byteString = atob(base64);
            const u8 = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
              u8[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([u8], { type: fileType });
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              const url = window.URL.createObjectURL(blob);
              const aLink = document.createElement("a");
              aLink.style.display = "none";
              aLink.download = filename;
              aLink.href = url;
              document.body.appendChild(aLink);
              aLink.click();
              document.body.removeChild(aLink);
              window.URL.revokeObjectURL(url);
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-dialog__body {
  min-height: 180px;
}

.calendar-dialog__toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.calendar-dialog__stats {
  display: flex;
  align-items: center;
}

.calendar-dialog__stat {
  margin-left: 16px;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;

  .calendar-dialog__stat-label {
    margin-right: 6px;
    color: #606266;
  }

  .calendar-dialog__stat-value {
    font-size: 16px;
    font-weight: bold;
  }

  &--total {
    background-color: #ecf5ff;

    .calendar-dialog__stat-value {
      color: #409eff;
    }
  }

  &--completed {
    background-color: #f0f9eb;

    .calendar-dialog__stat-value {
      color: #67c23a;
    }
  }
}

.calendar-dialog__legend {
  display: flex;
  align-items: center;
  margin-left: 16px;
  font-size: 12px;
  color: #909399;
}

.calendar-dialog__legend-dot {
  display: inline-block;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0 3px;
  margin-right: 4px;
  border-radius: 8px;
  background-color: #67c23a;
  color: #fff;
  font-size: 10px;
  text-align: center;
}

.calendar-dialog__calendar {
  border: 1px solid #ebeef5;

  /deep/ .el-calendar__header {
    display: none;
  }

  /deep/ .el-calendar__body {
    padding: 0;
  }

  /deep/ .el-calendar-table thead th {
    text-align: center;
  }

  /deep/ td.is-today {
    background-color: #fef0f0;

    .calendar-cell__day {
      color: #f56c6c;
      font-weight: bold;
    }
  }

  /deep/ .el-calendar-day {
    height: 64px;
    padding: 4px;
  }
}

.download-icon {
  cursor: pointer;
  font-size: 18px;
  color: #f56c6c;

  &:hover {
    color: #f78989;
  }
}
.calendar-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .calendar-cell__day {
    min-width: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #303133;
    text-align: center;
  }

  .calendar-cell__count {
    min-width: 20px;
    margin-top: 4px;
    padding: 0 5px;
    height: 18px;
    line-height: 18px;
    border-radius: 9px;
    background-color: #67c23a;
    color: #fff;
    font-size: 12px;
    text-align: center;
  }

  &--other {
    .calendar-cell__day {
      color: #c0c4cc;
    }
  }
}
</style>
